module.exports = __webpack_public_path__ + "assets/img/about.d2a8e970.jpg";